import moment from 'moment-timezone';

// The viewer's zone; tests pin it with moment.tz.setDefault.
const displayZone = () => moment().tz() ?? moment.tz.guess();

export const formatDateTime = (dateTime: string | null) => {
  if (!dateTime) {
    return '';
  }
  const utcTime = moment.utc(dateTime);
  // Midnight UTC is a date-only value; converting it would shift it to the previous day.
  if (utcTime.format('HH:mm:ss') === '00:00:00') {
    return utcTime.format('YYYY-MM-DD');
  }
  // Local time, like the date filter (local days). The zone label (CDT, MST, ...) keeps exported
  // CSVs unambiguous and follows daylight saving per value.
  return moment.tz(dateTime, displayZone()).format('YYYY-MM-DD HH:mm:ss z');
};

export const formatDate = (date: Date | null) => {
  if (!date) {
    return '';
  }
  return moment(date).format('yyyy-M-D');
};

export const stripPlus = (v: string) => v?.replace(/\+/, '') ?? '';
